"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIONS_GAP = exports.INNER_PADDING = exports.getBackgroundColor = exports.getColor = exports.getOuterPadding = void 0;
var colors_1 = require("../../theme/colors");
function getOuterPadding(padding) {
    if (typeof padding === 'number') {
        return padding;
    }
    switch (padding) {
        case 'default':
            return 12;
        case 'none':
            return 0;
        case 'narrow':
            return 4;
        default:
            return 12;
    }
}
exports.getOuterPadding = getOuterPadding;
function getColor(color) {
    switch (color) {
        case 'white':
            return '#FFFFFF';
        case 'light-grey':
            return colors_1.colors.steel[50];
        case 'light-blue':
            return colors_1.colors.brand[100];
        case 'light-yellow':
            return colors_1.colors.fire[100];
        default:
            return color;
    }
}
exports.getColor = getColor;
function getBackgroundColor(color, _a) {
    var isHovering = _a.isHovering, isHighlighted = _a.isHighlighted;
    if (isHighlighted) {
        return colors_1.colors.brand[100];
    }
    if (isHovering) {
        return colors_1.colors.steel[50];
    }
    switch (color) {
        case 'white':
            return '#FFFFFF';
        case 'light-grey':
            return colors_1.colors.steel[50];
        case 'light-blue':
            return colors_1.colors.brand[100];
        case 'light-yellow':
            return colors_1.colors.fire[100];
        default:
            return color;
    }
}
exports.getBackgroundColor = getBackgroundColor;
exports.INNER_PADDING = 4;
exports.ACTIONS_GAP = exports.INNER_PADDING * 1.5;
//# sourceMappingURL=utils.js.map